/*
 * @Author: 陈力恒
 * @Date: 2022-06-01 10:14:29
 * @LastEditors: 陈力恒
 * @LastEditTime: 2022-07-12 20:20:36
 * @Description: 要货配送属性model
 */

import type {
  IProductLocationPropModel,
  IProductLocationPropStore,
} from '@monorepo/types/orders/productLocationProp/productLocationProp.types';

const initState: IProductLocationPropStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    sort_order: 'CREATED_DESC',
  },
};

const productLocationProp: IProductLocationPropModel = {
  namespace: 'productLocationPropStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default productLocationProp;
